"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames"));

require("../styles/_tabs.scss");

function Tab(a) {
  var b = a.title,
      c = a.isSelected,
      d = a.onClick;
  return _react["default"].createElement("div", {
    role: "button",
    tabIndex: 0,
    className: (0, _classnames["default"])("tabs__tab", {
      "tabs__tab--selected": c
    }),
    onClick: d,
    onKeyPress: d
  }, _react["default"].createElement("span", {
    className: (0, _classnames["default"])("tabs__tab__title", {
      "tabs__tab__title--selected": c
    })
  }, b));
}

var _default = (0, _react.memo)(Tab);

exports["default"] = _default;